import axios from "@/lib/axios";

const getRegistration = () => {
  return axios.get("/customer/flat_rates/registration");
}

export default getRegistration;